module.exports = __webpack_public_path__ + "img/logo_cx .8a0ab5fd.png";